import { HeaderStyleModel } from '@/models/header/v2/HeaderModel'

export function formatHeaderStyle(data) {
  const h = new HeaderStyleModel()
  h.fromData(data)

  return h
}
